import { Helmet } from 'react-helmet-async'

import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import {
  getQueryParamsFromHash, parsePermittedQueryParams,
} from '@domain-group/javascript-utils'

import {
  Box,
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import useProviderAccount, { generateUrls, useProviderAccountForm } from '@hooks/useProviderAccount'

import PageHeader from '@components/PageHeader'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { AgencyModel } from '@models/types'

import Account from '../Account'
import AgencyOrderGraph from '../AgencyOrderGraph'
import PriceOverrides from '../PriceOverrides'
import ServiceBreakdown from '../ServiceBreakdown'

const PageContent = (props: { agency: AgencyModel, providerAccountId?: number }) => {
  const { agency, providerAccountId } = props
  const { id: agencyId, title: agencyTitle } = agency || {}

  const providerAccountPayload = useProviderAccount({ id: providerAccountId })
  const {
    callbacks: {
      createOrUpdateProviderAccount: createOrUpdateFn,
    },
    loaded,
    loading,
    provider,
    providerAccount,
    creating,
  } = providerAccountPayload

  const { redirect }: { redirect?: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const providerAccountFormPayload = useProviderAccountForm(providerAccount)
  const { entityState } = providerAccountFormPayload

  const createOrUpdateProviderAccountPayload = {
    callbacks: {
      action: createOrUpdateFn,
    },
    // @ts-expect-error TS2339
    entityParams: { ...entityState, agency_id: agencyId, provider_id: provider?.id },
    requestOptions: {
      include_provider_account_agency: true,
    },
    toastText: 'Provider Account Updated',
  }

  const { editProviderAccountRelationsUrl } = generateUrls({ agency_id: agencyId })

  return (
    <>
      <Helmet>
        <title>Provider Account | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || '#/systemManager/providerAgencies'}
            size="medium"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey="account"
        tabBarItems={[
          // @ts-expect-error TS2741
          {
            icon: faIdCard,
            key: 'account',
            title: agencyTitle,
          },
          {
            href: editProviderAccountRelationsUrl,
            icon: faIdCard,
            key: 'relations',
            title: 'Relations',
          },
        ]}
        title={agencyTitle}
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading && !loaded} times={3} />

            {agency.provider_metrics && <AgencyOrderGraph agency={agency} />}

            <Account providerAccountFormPayload={providerAccountFormPayload} />

            {/*
             // @ts-expect-error TS2339 */}
            <PriceOverrides agencyId={agencyId} providerId={provider.id} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                loading={creating}
                marginLeft="auto"
                // @ts-expect-error TS2345
                onClick={() => handleCallbackAction(createOrUpdateProviderAccountPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </Columns.Main>

          <Columns.Sidebar>
            {agency.provider_metrics && <ServiceBreakdown agencyId={agencyId} />}
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
